import { render, staticRenderFns } from "./AlertLayout.vue?vue&type=template&id=198e18fc"
import script from "./AlertLayout.vue?vue&type=script&lang=js"
export * from "./AlertLayout.vue?vue&type=script&lang=js"
import style0 from "./AlertLayout.vue?vue&type=style&index=0&id=198e18fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports